/* ==========================================================================
   QE Headphone Branding calculator
   --------------------------------------------------------------------------
   Drives the theme's product form without modifying it:
     · reads the selected variant from the form's hidden [name="id"]
       (owned and updated by the theme's variant-picker block)
     · writes the CAP count into the form's hidden [name="quantity"]
     · keeps the line item properties in sync

   THE ÷2 RULE — do not "simplify" this away.
   Tiers are priced per CAP and each headphone has 2 caps, so a band that reads
   "100–150 caps @ $4.40" needs 50 headphones, not 100. Feeding the raw band
   threshold in as headphones doubles the caps and quietly prices one band down.
   ========================================================================== */
(function () {
  'use strict';

  var QEB_FEES = {};

  function qebRefreshCart() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.refresh === 'function') { try { d.refresh(true); } catch (e) {} }
  }

  function qebReconcileFees() {
    var mapped = Object.keys(QEB_FEES);
    if (!mapped.length) return;
    var feeIds = {};
    mapped.forEach(function (k) { feeIds[QEB_FEES[k]] = true; });

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var required = {}, present = {};
        (cart.items || []).forEach(function (it) {
          var vid = String(it.variant_id);
          if (QEB_FEES[vid]) required[QEB_FEES[vid]] = true;
          if (feeIds[vid]) present[vid] = it;
        });
        var toAdd = Object.keys(required).filter(function (id) { return !present[id]; });
        var toFix = Object.keys(present).filter(function (id) {
          return !required[id] || present[id].quantity !== 1;
        });
        if (!toAdd.length && !toFix.length) return;

        var chain = Promise.resolve();
        toAdd.forEach(function (id) {
          chain = chain.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
            });
          });
        });
        toFix.forEach(function (id) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: present[id].key, quantity: required[id] ? 1 : 0 })
            });
          });
        });
        chain.then(qebRefreshCart).catch(function () {});
      })
      .catch(function () {});
  }

  function boot(root) {
    if (root.dataset.qebReady === '1') return;
    root.dataset.qebReady = '1';

    /* ---------- parse the data emitted by the snippet ---------- */
    var methods = {};
    (root.dataset.rows || '').split('~').forEach(function (line) {
      var f = line.trim().split('|');
      if (f.length < 8) return;
      var min = parseInt(f[5], 10) || 1;
      methods[f[0]] = {
        id: f[0],
        key: f[1],
        label: f[2],
        unit: f[3],
        unitPlural: f[4],
        min: min,
        /* field 7 — the headphone count the stepper jumps to for this method.
           Clamped up to the minimum so a too-low value can never be set. */
        start: Math.max(parseInt(f[6], 10) || 0, Math.ceil(min / 2)),
        tiers: f[7].split(',').map(function (b) {
          var p = b.split(':');
          return { lo: parseInt(p[0], 10), price: parseFloat(p[1]) };
        }),
        fee: (f[9] || '').split(':')[0] || '',
        feeAmount: parseFloat((f[9] || '').split(':')[1] || 0) || 0
      };
    });
    if (!Object.keys(methods).length) return;

    Object.keys(methods).forEach(function (k) {
      if (methods[k].fee) QEB_FEES[k] = methods[k].fee;
    });
    if (!window.__qebFeesBound) {
      window.__qebFeesBound = true;
      document.addEventListener('on:cart:add', function () { setTimeout(qebReconcileFees, 80); });
      setTimeout(qebReconcileFees, 400);
    }

    var form = document.getElementById(root.dataset.formId);
    if (!form) return;

    var hp        = root.querySelector('[data-qeb-hp]');
    var warnEl    = root.querySelector('[data-qeb-warn]');
    var methodEl  = root.querySelector('[data-qeb-methodlabel]');
    var headsEl   = root.querySelector('[data-qeb-heads]');
    var tierEl    = root.querySelector('[data-qeb-tier]');
    var unitLabel = root.querySelector('[data-qeb-unitlabel]');
    var unitsEl   = root.querySelector('[data-qeb-units]');
    var priceEl   = root.querySelector('[data-qeb-unitprice]');
    var totalEl   = root.querySelector('[data-qeb-total]');
    var setupEl   = root.querySelector('[data-qeb-setup]');
    var setupRow  = root.querySelector('[data-qeb-setuprow]');
    var liveEl    = root.querySelector('[data-qeb-live]');
    var propHp    = root.querySelector('[data-qeb-prop-hp]');
    var propCaps  = root.querySelector('[data-qeb-prop-caps]');

    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: currency
    });
    var num = new Intl.NumberFormat(document.documentElement.lang || 'en');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function currentMethod() {
      var idInput = form.querySelector('[name="id"]');
      var id = idInput ? String(idInput.value) : '';
      return methods[id] || methods[Object.keys(methods)[0]];
    }

    function tierFor(m, units) {
      var t = m.tiers[0];
      for (var i = 0; i < m.tiers.length; i++) if (units >= m.tiers[i].lo) t = m.tiers[i];
      return t;
    }

    /* "151–300" / "1,001+" for the Volume tier row. The upper bound is the next
       band's threshold minus one, so it always matches the printed tier table. */
    function tierLabel(m, t) {
      var i = m.tiers.indexOf(t);
      var next = m.tiers[i + 1];
      return next ? num.format(t.lo) + '–' + num.format(next.lo - 1)
                  : num.format(t.lo) + '+';
    }

    function render(bump) {
      var m = currentMethod();
      var heads = Math.max(1, parseInt(hp.value, 10) || 1);
      var units = heads * 2;                       /* ← the ÷2 rule, in reverse */
      var tier  = tierFor(m, units);
      var ok    = units >= m.min;
      var setup = m.feeAmount || 0;
      var total = units * tier.price + setup;

      /* show only this variant's tier table, highlight the active band */
      root.querySelectorAll('[data-qeb-tiers]').forEach(function (box) {
        var on = box.getAttribute('data-qeb-tiers') === m.id;
        box.hidden = !on;
        box.querySelectorAll('[data-qeb-band]').forEach(function (li) {
          li.classList.toggle('is-active', on && ok && parseInt(li.getAttribute('data-qeb-band'), 10) === tier.lo);
        });
      });

      /* per-variant note — only the 30% Discount variant has one */
      root.querySelectorAll('[data-qeb-note]').forEach(function (note) {
        note.hidden = note.getAttribute('data-qeb-note') !== m.id;
      });

      if (methodEl) methodEl.textContent = m.label;
      if (headsEl)  headsEl.textContent  = num.format(heads);
      if (tierEl) tierEl.textContent = ok ? tierLabel(m, tier) : '—';
      unitLabel.textContent = m.unitPlural;
      unitsEl.textContent   = num.format(units);
      priceEl.textContent   = money.format(tier.price);
      if (setupRow) setupRow.hidden = !(setup > 0);
      if (setupEl)  setupEl.textContent = setup > 0 ? money.format(setup) : '—';
      totalEl.textContent   = money.format(total);

      warnEl.hidden = ok;
      if (!ok) {
        warnEl.textContent = num.format(units) + ' ' + m.unitPlural.toLowerCase() +
          ' is below the minimum of ' + num.format(m.min) + '.';
      }

      /* drive the theme's form */
      var qty = form.querySelector('[name="quantity"]');
      if (qty) qty.value = units;
      if (propHp)   propHp.value   = String(heads);
      if (propCaps) propCaps.value = String(units);

      /* block submit below the minimum rather than letting a bad order through */
      var submit = form.querySelector('[name="add"]');
      if (submit) {
        submit.disabled = !ok;
        submit.setAttribute('aria-disabled', String(!ok));
      }

      if (liveEl) {
        liveEl.textContent = m.label + ', ' + num.format(heads) + ' headphones, ' +
          num.format(units) + ' ' + m.unitPlural.toLowerCase() + ' at ' + money.format(tier.price) +
          '. Estimated total ' + money.format(total) + '.';
      }

      Array.prototype.slice.call(root.querySelectorAll('[data-qeb-q]')).forEach(function (b) {
        b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-qeb-q'), 10) === heads));
      });

      if (bump && !reduce) {
        totalEl.classList.remove('is-bump');
        void totalEl.offsetWidth;
        totalEl.classList.add('is-bump');
        setTimeout(function () { totalEl.classList.remove('is-bump'); }, 320);
      }
    }

    function setHp(v) { hp.value = Math.max(1, v | 0); render(true); }

    /* Fewest headphones that satisfies a method's minimum.
       Minimums are in caps/stickers and each headphone has 2:
       Stickers 20 → 10 · Stickers 30% 20 → 10 · UV 10 → 5 · Etched 100 → 50 */
    function minHeadphones(m) { return Math.ceil(m.min / 2); }

    var pendingBand = 0;

    window.QEBBand = function (variantId, lo) {
      pendingBand = parseInt(lo, 10) || 0;
      if (typeof window.QEBPick === 'function') window.QEBPick(variantId);
      var apply = function () {
        if (!pendingBand) return;
        var m = currentMethod();
        var v = Math.max(minHeadphones(m), Math.ceil(pendingBand / 2));
        if (parseInt(hp.value, 10) !== v) { hp.value = v; render(true); }
      };
      apply();
      setTimeout(apply, 80);
      setTimeout(apply, 260);
      setTimeout(function () { pendingBand = 0; }, 700);
      return true;
    };

    /* Runs when the branding method changes — never while typing, or it would
       fight the customer as they type their way up to a bigger number.
       Sets the stepper to that method's `start` value (field 7 of the data row
       in qe-branding-calculator.liquid).

       To switch to "only raise, never lower a quantity the customer typed",
       replace the hp.value line with:
           if ((parseInt(hp.value, 10) || 0) < m.start) hp.value = m.start;
    */
    function syncToMethod(bump) {
      var m = currentMethod();
      hp.min = minHeadphones(m);
      hp.value = pendingBand ? Math.max(minHeadphones(m), Math.ceil(pendingBand / 2)) : m.start;
      render(bump !== false);
    }

    /* quick quantity pills — set the headphone count directly */
    Array.prototype.slice.call(root.querySelectorAll('[data-qeb-q]')).forEach(function (b) {
      b.addEventListener('click', function () { setHp(parseInt(b.getAttribute('data-qeb-q'), 10)); });
    });

    root.querySelector('[data-qeb-inc]').addEventListener('click', function () {
      setHp((parseInt(hp.value, 10) || 0) + 1);
    });
    root.querySelector('[data-qeb-dec]').addEventListener('click', function () {
      setHp((parseInt(hp.value, 10) || 1) - 1);
    });
    hp.addEventListener('input', function () { render(false); });

    /* clicking a tier band loads the quantity that lands in it */
    root.addEventListener('click', function (e) {
      var li = e.target.closest('[data-qeb-band]');
      if (!li || !root.contains(li)) return;
      setHp(Math.ceil(parseInt(li.getAttribute('data-qeb-band'), 10) / 2));
    });

    /* ----------------------------------------------------------------------
       PAGE MODE — no variant-picker exists, so this segmented control writes
       the variant straight into the form's hidden [name="id"], which is exactly
       what the variant-picker does on the PDP. Everything downstream is shared.
       ---------------------------------------------------------------------- */
    var seg = root.querySelector('[data-qeb-seg]');
    if (seg) {
      var picks = Array.prototype.slice.call(seg.querySelectorAll('[data-qeb-pick]'));
      var order = picks.map(function (b) { return b.getAttribute('data-qeb-pick'); });

      var moveThumb = function (id) {
        var i = Math.max(0, order.indexOf(String(id)));
        seg.style.setProperty('--qeb-seg-i', i);            /* ≥520px: one row of 4 */
        seg.style.setProperty('--qeb-seg-x', i % 2);        /* <520px: 2 × 2 grid   */
        seg.style.setProperty('--qeb-seg-y', Math.floor(i / 2));
      };

      picks.forEach(function (b) {
        b.addEventListener('click', function () {
          var id = b.getAttribute('data-qeb-pick');
          var hidden = form.querySelector('[name="id"]');
          if (hidden) { hidden.value = id; hidden.removeAttribute('disabled'); }
          picks.forEach(function (x) {
            x.setAttribute('aria-pressed', String(x === b));
          });
          moveThumb(id);
          syncToMethod();
        });
      });

      /* Re-assert the pressed state from the form on boot rather than trusting
         the server-rendered attribute — one source of truth, and it survives a
         Liquid type mismatch. */
      var startId = String((form.querySelector('[name="id"]') || {}).value || order[0] || '');
      picks.forEach(function (x) {
        x.setAttribute('aria-pressed', String(x.getAttribute('data-qeb-pick') === startId));
      });
      moveThumb(startId);
    }

    /* ----------------------------------------------------------------------
       ONE WAY TO SELECT A METHOD, whichever mode this is running in.
       Page mode has the segmented control above; the PDP has the theme's
       variant-picker, whose radios are keyed by OPTION VALUE, not variant id —
       so it is the method's own label from the data rows that matches them.
       Exported because the landing sections' "Order Now" buttons and tier rows
       need to select a method too, and they must not each grow their own copy.
       ---------------------------------------------------------------------- */
    window.QEBPick = function (variantId) {
      var id = String(variantId || '');
      var m = methods[id];

      /* page mode — let the segmented control's own handler do the work */
      var segBtn = root.querySelector('[data-qeb-pick="' + id + '"]');
      if (segBtn) { segBtn.click(); return true; }

      /* PDP — tick the theme radio whose value is this method's label */
      if (m && m.label) {
        var want = m.label.trim().toLowerCase();
        var radios = document.querySelectorAll('variant-picker input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (String(radios[i].value).trim().toLowerCase() !== want) continue;
          if (!radios[i].checked) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
      }

      /* last resort: write the form directly. Only correct when no picker
         exists — otherwise the picker's UI would disagree with the form. */
      var hidden = form.querySelector('[name="id"]');
      if (!hidden || document.querySelector('variant-picker')) return false;
      hidden.value = id;
      hidden.removeAttribute('disabled');
      syncToMethod();
      return true;
    };

    /* the variant-picker rewrites [name="id"]; resync whenever it does */
    var idInput = form.querySelector('[name="id"]');
    if (idInput && 'MutationObserver' in window) {
      new MutationObserver(syncToMethod)
        .observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }
    form.addEventListener('change', function (e) {
      if (e.target.name === 'id' || e.target.closest('variant-picker')) syncToMethod();
    });
    document.addEventListener('variant:change', function () { syncToMethod(); });

    /* ----------------------------------------------------------------------
       ARTWORK VALIDATION
       `accept` only filters the file picker — the customer can still pick "All
       files" — so the extension is re-checked here and the input is cleared on
       a bad pick, which keeps `required` unsatisfied and blocks the form.

       Resolution: pixel dimensions of PNG/JPG are readable in the browser.
       DPI is NOT — it lives in EXIF/JFIF metadata that is frequently absent or
       wrong, so "300 DPI" cannot be verified here. Vector files (PDF, AI, EPS,
       SVG) are resolution-independent and are passed without measurement.
       ---------------------------------------------------------------------- */
    var ART_OK     = ['pdf', 'ai', 'eps', 'svg', 'png', 'jpg', 'jpeg'];
    var ART_RASTER = ['png', 'jpg', 'jpeg'];
    var MIN_PX     = 2000;                 /* shortest side, in px — tune to your press spec */
    var MAX_BYTES  = 20 * 1024 * 1024;     /* ⚠ UNVERIFIED: Shopify does not document the
                                              line-item-property upload cap. Confirm by
                                              testing a large file, then correct this. */

    var fileInput = root.querySelector('[data-qeb-file]');
    var fileMsg   = root.querySelector('[data-qeb-filemsg]');

    function setFileMsg(kind, text) {
      if (!fileMsg) return;
      fileMsg.hidden = !text;
      fileMsg.textContent = text || '';
      fileMsg.className = 'qeb__filemsg' + (kind ? ' is-' + kind : '');
    }

    function rejectFile(msg, validity) {
      fileInput.value = '';
      fileInput.setCustomValidity(validity || msg);
      setFileMsg('error', msg);
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var f = fileInput.files && fileInput.files[0];
        fileInput.setCustomValidity('');
        if (!f) { setFileMsg('', ''); return; }

        var ext = (f.name.split('.').pop() || '').toLowerCase();

        if (ART_OK.indexOf(ext) === -1) {
          rejectFile('.' + ext + ' files are not accepted. Use PDF, AI, EPS, SVG, JPG or PNG.',
                     'Choose a PNG, JPG, PDF, AI, EPS or SVG file.');
          return;
        }
        if (f.size > MAX_BYTES) {
          rejectFile('That file is ' + (f.size / 1048576).toFixed(1) + ' MB. Please keep it under ' +
                     (MAX_BYTES / 1048576) + ' MB.', 'File is too large.');
          return;
        }
        if (ART_RASTER.indexOf(ext) === -1) {
          setFileMsg('ok', ext.toUpperCase() + ' is a vector format — it stays sharp at any print size.');
          return;
        }

        /* raster — measure the actual pixel dimensions */
        var url = URL.createObjectURL(f);
        var img = new Image();
        img.onload = function () {
          URL.revokeObjectURL(url);
          var w = img.naturalWidth, h = img.naturalHeight;
          if (Math.min(w, h) < MIN_PX) {
            setFileMsg('warn', w + ' × ' + h + ' px. That is under ' + MIN_PX +
              ' px on the shortest side and may print soft. A larger image, or a vector file ' +
              '(PDF, AI, EPS, SVG), will print sharper.');
          } else {
            setFileMsg('ok', w + ' × ' + h + ' px — good resolution for print.');
          }
        };
        img.onerror = function () {
          URL.revokeObjectURL(url);
          setFileMsg('warn', 'Could not read the dimensions of that image, so its resolution has not been checked.');
        };
        img.src = url;
      });
    }

    syncToMethod(false);   /* seed hp.min + starting quantity, no bump on first paint */
  }

  function init() {
    document.querySelectorAll('[data-qeb]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* re-boot after a theme-editor section reload */
  document.addEventListener('shopify:section:load', init);
})();
